import avatar from "assets/img/avatars/dan.jpg";
import { Link } from "react-router-dom";
import { SVG } from "ui";

const MessagesDropdown = () => {
    return (
        <div
            className="navbar-item is-icon drop-trigger"
            id="messages-toolbar-dropdown"
        >
            {/* <!-- add 'is-active' class to the below to show if there's a message  --> */}
            <a className="icon-link is-active">
                {/* <i data-feather="mail"></i> */}
                <SVG svg="mail" size={18} className="light-grey-svg" />
                <span className="indicator">291</span>
            </a>

            <div className="nav-drop is-right">
                <div className="inner">
                    <div className="nav-drop-header">
                        <span>Messages</span>
                        <a href="messages-inbox.html">Inbox</a>
                    </div>
                    <div className="nav-drop-body is-friend-requests">
                        {/* <!-- Message --> */}
                        <div className="media">
                            <figure className="media-left">
                                <p className="image">
                                    <img
                                        src={avatar}
                                        data-user-popover="9"
                                        alt=""
                                    />
                                </p>
                            </figure>
                            <Link to="/chat/demo" className="media-content">
                                <a href="#">Nelly Schwartz</a>
                                <span>
                                    I think we should meet near the Starbucks so
                                    we can get...
                                </span>
                                <span className="time">Yesterday</span>
                            </Link>
                            {/* <div className="media-right is-centered">
                                <div className="added-icon">
                                    <i data-feather="message-square"></i>
                                </div>
                            </div> */}
                        </div>
                        {/* <!-- Message --> */}
                        <div className="media">
                            <figure className="media-left">
                                <p className="image">
                                    <img
                                        src={avatar}
                                        // data-demo-src="assets/img/avatars/edward.jpeg"
                                        data-user-popover="5"
                                        alt=""
                                    />
                                </p>
                            </figure>
                            <Link to="/chat/demo" className="media-content">
                                <a href="#">Edward Mayers</a>
                                <span>
                                    That was a real pleasure seeing you last
                                    time we really should...
                                </span>
                                <span className="time">last week</span>
                            </Link>
                            <div className="media-right is-centered">
                                <div className="added-icon">
                                    <i data-feather="message-square"></i>
                                </div>
                            </div>
                        </div>
                        {/* <!-- Message --> */}
                        <div className="media">
                            <figure className="media-left">
                                <p className="image">
                                    <img
                                        src={avatar}
                                        // data-demo-src="assets/img/avatars/dan.jpg"
                                        data-user-popover="1"
                                        alt=""
                                    />
                                </p>
                            </figure>
                            <Link to="/chat/demo" className="media-content">
                                <a href="#">Dan Walker</a>
                                <span>
                                    Hey there, would it be possible to borrow
                                    your bicycle, i really need...
                                </span>
                                <span className="time">Jun 03 2018</span>
                            </Link>
                            <div className="media-right is-centered">
                                <div className="added-icon">
                                    <i data-feather="message-square"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="nav-drop-footer">
                        <Link to="/chat">View All</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MessagesDropdown;
